module.exports = __webpack_public_path__ + "static/media/arrow-line-right-light.4a17378e.svg";